import { DATE_TIME_LOCAL_FORMAT } from "@dgs/core";
import { isAfter, isBefore, parse, parseISO } from "date-fns";
import { DataFieldType } from "../../../shared/types";
import { DataFieldRuleValidator } from "./types";

export const dataFieldBetween: DataFieldRuleValidator = {
	validate({ isImplicitlyRequired }, dataFieldType, dataFieldValue, ruleValue): boolean {
		if (dataFieldValue === null || dataFieldValue === undefined || !ruleValue) {
			return !isImplicitlyRequired;
		}

		const { start, end } = ruleValue as { start: string; end: string };

		switch (dataFieldType) {
			case DataFieldType.DATETIME: {
				const value = parseISO(dataFieldValue as string);
				return !isBefore(value, parseISO(start)) && !isAfter(value, parseISO(end));
			}
			case DataFieldType.LOCAL_DATETIME: {
				const value = parse(dataFieldValue as string, DATE_TIME_LOCAL_FORMAT, new Date());
				return (
					!isBefore(value, parse(start, DATE_TIME_LOCAL_FORMAT, new Date())) &&
					!isAfter(value, parse(end, DATE_TIME_LOCAL_FORMAT, new Date()))
				);
			}
			case DataFieldType.DATE: {
				const value = parse(dataFieldValue as string, "yyyy-MM-dd", new Date());
				return (
					!isBefore(value, parse(start, "yyyy-MM-dd", new Date())) &&
					!isAfter(value, parse(end, "yyyy-MM-dd", new Date()))
				);
			}
		}
		return false;
	},
	getErrorMessage({ t, formatDate, formatDateTime }, dataField, _, ruleValue): string {
		const { start, end } = ruleValue as { start: string; end: string };
		switch (dataField.type) {
			case DataFieldType.DATETIME:
			case DataFieldType.LOCAL_DATETIME:
				return t("Field must be between {{start}} and {{end}}", {
					start: formatDateTime(start),
					end: formatDateTime(end),
				});
			default:
				return t("Field must be between {{start}} and {{end}}", {
					start: formatDate(start),
					end: formatDate(end),
				});
		}
	},
};
